import { ButtonIcon } from "components/buttons/button-icon/button-icon";
import { ButtonStyle, ButtonSize } from "components/buttons/button/button";
import { DataTable } from "components/tables/data-table/data-table";
import { Icons } from "components/icons/constants/icons";
import { ProviderRecord } from "models/view-models/providers/provider-record";
import { SelectableProvider } from "models/interfaces/providers/selectable-provider";
import { t } from "utilities/localization/t";
import "./event-provider-selection-list.scss";

// -------------------------------------------------------------------------------------------------
// #region Interfaces
// -------------------------------------------------------------------------------------------------

interface EventProviderSelectionListProps {
    handleAdd: (provider: ProviderRecord) => void;
    handleRemove: (provider: ProviderRecord) => void;
    selectableProviders: SelectableProvider[];
}

// #endregion Interfaces

// -------------------------------------------------------------------------------------------------
// #region Constants
// -------------------------------------------------------------------------------------------------

const CSS_CLASS_NAME = "event-provider-selection-list";

// #endregion Constants

// -------------------------------------------------------------------------------------------------
// #region Component
// -------------------------------------------------------------------------------------------------

const EventProviderSelectionList: React.FC<EventProviderSelectionListProps> = (
    props: EventProviderSelectionListProps
) => {
    return (
        <DataTable cssClassName={CSS_CLASS_NAME}>
            <thead>
                <tr>
                    <th className="provider-name">{t("providerName")}</th>
                    <th className="id">{t("id")}</th>
                    <th className="action">{t("action")}</th>
                </tr>
            </thead>
            <tbody>
                {props.selectableProviders.length === 0 && (
                    <tr>
                        <td colSpan={3} className={"-no-results-row"}>
                            {t("noProvidersFound")}
                        </td>
                    </tr>
                )}
                {props.selectableProviders.map((selectableProvider) => (
                    <tr key={selectableProvider.provider.id}>
                        <td className="provider-name">{selectableProvider.provider.name}</td>
                        <td className="id">{selectableProvider.provider.id}</td>
                        <td className="action">
                            {!selectableProvider.isSelected && (
                                <ButtonIcon
                                    buttonSize={ButtonSize.Small}
                                    buttonStyle={ButtonStyle.Secondary}
                                    iconType={Icons.Plus}
                                    onClick={() => props.handleAdd(selectableProvider.provider)}
                                    text={t("add")}
                                />
                            )}
                            {selectableProvider.isSelected && (
                                <ButtonIcon
                                    buttonSize={ButtonSize.Small}
                                    buttonStyle={ButtonStyle.Primary}
                                    iconType={Icons.Minus}
                                    onClick={() => props.handleRemove(selectableProvider.provider)}
                                    text={t("remove")}
                                />
                            )}
                        </td>
                    </tr>
                ))}
            </tbody>
        </DataTable>
    );
};

// #endregion Component

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export { EventProviderSelectionList };

// #endregion Exports
